import styled from 'styled-components';
import { theme } from '../../theme';

export const StyledRangeSlider = styled.div`
  width: 100%;
  .horizontal-slider {
    width: 100%;
    max-width: 500px;
    height: 50px;
    margin-top: ${theme.spacings[9].rem};
  }

  .slider-thumb {
    background: ${theme.colors.primary.graysBlue};
    cursor: pointer;
    font-size: 0;
    border: 0;
  }

  .slider-thumb-0:before,
  .slider-thumb-1:before {
    top: 0;
    left: 50%;
    transform: translate(-50%, calc(-100% - 5px)) rotate(45deg);
    background-color: ${theme.colors.primary.graysGray};
    content: ' ';
    display: block;
    position: absolute;
    width: 15px;
    height: 15px;
    z-index: 999;
  }

  .slider-thumb-0:after,
  .slider-thumb-1:after {
    content: attr(aria-valuenow);
    top: 0;
    left: 50%;
    transform: translate(-50%, calc(-100% - 10px));
    background-color: ${theme.colors.primary.graysGray};
    color: ${theme.colors.primary.white};
    display: block;
    padding: 4px;
    min-width: 25px;
    width: fit-content;
    line-height: 13px;
    position: absolute;
    text-align: center;
    z-index: 999;
    font-size: 10px;
  }

  .slider-thumb.active {
    background: ${theme.colors.primary.graysBlue};
  }
  .slider-thumb:focus-visible {
    outline: 0;
    border: 0;
  }
  .slider-track {
    position: relative;
    background: ${theme.colors.neutrals.solidGrays[5]};
  }
  .slider-track.slider-track-1 {
    background: ${theme.colors.tints.graysBlue[3]};
  }
  .slider-track.slider-track-2 {
    background: ${theme.colors.neutrals.solidGrays[5]};
  }

  .horizontal-slider .slider-track {
    top: 20px;
    height: 5px;
    border-radius: 10px;
  }
  .horizontal-slider .slider-thumb {
    top: 12px;
    width: 18px;
    height: 18px;
    border-radius: 50px;
  }
  .horizontal-slider .example-mark {
    margin: 0 calc(25px - 6px);
    bottom: calc(50% - 6px);
  }
`;
